module.exports = __webpack_public_path__ + "img/farzana-christopher-150.b27fe1b9.jpg";